import { render, staticRenderFns } from "./IdleVehiclePanel.vue?vue&type=template&id=4f110516&scoped=true"
import script from "./IdleVehiclePanel.vue?vue&type=script&lang=js"
export * from "./IdleVehiclePanel.vue?vue&type=script&lang=js"
import style0 from "./IdleVehiclePanel.vue?vue&type=style&index=0&id=4f110516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f110516",
  null
  
)

export default component.exports